import React from 'react' 
import DateTimePicker from 'react-datetime-picker';
import PreviewSurvey from '../PreviewSurvey'
import { updateInput } from '../../../../../../features/create-project/create-project-slice'
import Evaluators from '../Evaluators';
import { useSelector, useDispatch } from 'react-redux'

const AddProjectForm = () => {

 const { formData , errors  }  = useSelector( state => state.createProjectForm )
 const dispatch = useDispatch()

 const handleInput = (e) => {
      if(e.target.name === 'evaluator' || e.target.name === 'development_coach'){
          const selected =   Boolean(parseInt(e.target.value))
         dispatch( updateInput({ name : e.target.name , value : selected }) )
      }
      else {
          dispatch( updateInput({ name : e.target.name , value : e.target.value }) )
      }
 }

  const handleDateInput = (name,value) => {
    dispatch( updateInput({ name, value }) )
   }

 return (
   <form>  
      <div className='px-2 md:px-12'>         
         <div className='flex items-center'> 
             <div className='w-[120px] text-sm'> Project Name: </div>
              <div className='w-[300px]'>
                  <input 
                       type='text' className='admin-form-input'
                       placeholder='project name...'
                       style={{ padding:'10px' }}
                       onChange = {  handleInput }
                       name='project_name'
                       value = { formData.project_name }
                  />
              </div>
        </div>
        <div className='mt-1 text-red-500 text-[13px] ml-[125px]'> 
            { errors.project_name  } 
        </div>

        <div className='flex items-center mt-5'> 
             <div className='w-[120px] text-sm'> Description: </div>
              <div className='w-[300px]'>
                  <textarea
                       type='text' className='admin-form-input h-[80px]'                       
                       style={{ padding:'10px' }}
                       placeholder='description...'
                       onChange = {  handleInput }
                       value = { formData.project_description }
                       name='project_description'
                  />
              </div>
        </div>
        <div className='mt-1 text-red-500 text-[13px] ml-[125px]'> 
            { errors.project_description  } 
        </div>

         <div className='flex justify-between'>
              <div className='flex items-center justify-between mt-5'> 
                  <div className='md:w-[100px] xl:w-[120px] text-sm'> Start Date:  </div>
                    <div className='w-[300px] relative'>                                             
                         <div className='w-full'>                                                                                                                        
                            <DateTimePicker 
                              onChange = { (e) =>  handleDateInput('start_date',e) }
                              value = { formData.start_date }
                              name='start_date'
                              className = 'date-picker'
                              calendarIcon = {
                                     <span   className=' bi bi-calendar text-red-500'></span>
                                 }
                              format = 'dd-MM-y h:mm:ss a'        
                              dayPlaceholder = 'dd'                                                                                
                              monthPlaceholder = 'mm'
                              yearPlaceholder = 'yyyy'
                              hourPlaceholder = 'h'
                              minutePlaceholder = 'm'
                              secondPlaceholder = 's'                              
                            />    
                        </div>
                      <div className='mt-1 text-red-500 text-[13px]'> { errors.start_date_and_time } </div>
                  </div>
              </div>

              <div className='flex items-center justify-between mt-5'> 
                  <div className='md:w-[80px] xl:w-[100px] md:ml-3 xl:ml-0 text-sm'> End Date:  </div>
                    <div className='w-[300px] relative'>                    
                         <div className='w-full'>                                
                            <DateTimePicker 
                                onChange = { (e) =>  handleDateInput('end_date',e) }
                                value = { formData.end_date }
                                name='end_date'
                                className = 'date-picker'
                                calendarIcon = {
                                        <span   className=' bi bi-calendar text-red-500'></span>
                                    }
                                format = 'dd-MM-y h:mm:ss a'     
                                dayPlaceholder = 'dd'                                                                                
                                monthPlaceholder = 'mm'
                                yearPlaceholder = 'yyyy'
                                hourPlaceholder = 'h'
                                minutePlaceholder = 'm'
                                secondPlaceholder = 's'            
                                minDate = { formData.start_date }                                                                           
                                />                                                                         
                         </div>
                         <div className='text-red-500 text-[13px] mt-1'> { errors.end_date_and_time } </div>
                  </div>
              </div>
         </div>        
      </div>
       <div className='bg-gray-100 py-3 text-sm mt-5 pl-3'>
           <span className='bi bi-gear mr-1'></span>  Settings
        </div>
         <Evaluators className={'w-[80%]'} />
        <h6 className='mt-8 text-md pl-5 font-semibold'>Survey </h6>
        <p className='py-2 ml-5 border-b  text-green-700 border-gray-300 text-sm w-[80%]'> Survey for each roles </p>
         
         <PreviewSurvey handleInput={ handleInput } />

        <h6 className='mt-8 text-md pl-5 font-semibold'>Evaluators </h6>
        <p className='py-2 ml-5 border-b  text-green-700 border-gray-300 text-sm w-[80%]'> Upload Evaluators </p>        
        <div className='mt-5 px-5 flex'>             
                 <div className='form-check form-check-inline'>                      
                      <input 
                            className='admin-form-check'  
                            type='radio' name='evaluator' 
                            id='inlineRadio1' value={ 1 }
                            defaultChecked = { true }
                            onChange = { handleInput }
                       />
                       <label className='form-check-label text-sm ml-3 inline-block text-gray-800' htmlFor='inlineRadio1'>
                          I will select evaluators
                       </label>
                  </div>
                  <div className='form-check form-check-inline ml-[5rem]'>                      
                      <input 
                            className='admin-form-check' 
                            type='radio' name='evaluator' 
                            id='inlineRadio1' value= { 0 }                            
                            onChange = { handleInput }
                       />
                       <label className='form-check-label text-sm ml-3 inline-block text-gray-800' htmlFor='inlineRadio1'>
                          Let partcipants choose their  evaluators
                       </label>
                  </div>
        </div>

        <h6 className='mt-8 text-md pl-5 font-semibold'>Development Coach </h6>
        <p className='py-2 ml-5 border-b  text-green-700 border-gray-300 text-sm w-[80%]'> Upload Evaluators </p>        
        <div className='mt-5 px-5 flex'>             
                 <div className='form-check form-check-inline'>                      
                      <input 
                            className='admin-form-check' 
                            type='radio' name='development_coach'                             
                            id='inlineRadio1' value= { 1 }
                            defaultChecked = { true }
                            onChange = { handleInput }
                       />
                       <label className='form-check-label text-sm ml-3 inline-block text-gray-800' for='inlineRadio1'>
                          I will select evaluators
                       </label>
                  </div>
                  <div className='form-check form-check-inline ml-[5rem]'>                      
                      <input 
                            className='admin-form-check' 
                            type='radio' name='development_coach' 
                            id='inlineRadio1' value={ 0 }                             
                            onChange = { handleInput }
                       />
                       <label className='form-check-label text-sm ml-3 inline-block text-gray-800' for='inlineRadio1'>
                          Let partcipants choose their  evaluators
                       </label>
                  </div>
        </div>
   </form>
  )
}

export default AddProjectForm

 
   
    
  